const userRolesConstant = {
  LEGAL_ADMIN: "legal:admin",
  LEGAL_MANAGER: "legal:manager",
  SUPER_USER: "legal:superuser",
  LEGAL_ADVISOR: "legal:advisor",
};

export { userRolesConstant };
